import Colors from "../../../../utils/Colors";

export default function BotAvatar({
  assistantId,
  style,
  getInternalStyle,
}: any) {
  return (
    <div className="bot-avatar-container">
      {true ? (
        <img
          src={getInternalStyle(assistantId, style).messages.bot.icon}
          alt="Bot Avatar"
          className="bot-avatar"
        />
      ) : (
        <div
          className="bot-avatar bot-avatar-default"
          style={{
            backgroundColor: Colors.lightenHexColor(style.color, 30),
            color: Colors.lightenHexColor(style.color, -20),
            border: `2px solid ${Colors.lightenHexColor(style.color, 10)}`,
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 8V4H8" />
            <rect width="16" height="12" x="4" y="8" rx="2" />
            <path d="m9 16 .5-1 .5 1h2l.5-1 .5 1" />
            <path d="M9 12h6" />
          </svg>
        </div>
      )}
    </div>
  );
}
